export interface IOrganizationData {
    companyName: string;
    address: string;
    address2: string | null;
    zip: string | null;
    country?: string;
    city: string | null;
    telephone: string;
    email: string;
    logoBase64?: string;
}
